// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Container imports
const TopCallToActionExplainerApp = require('./explainer-app-dumb')

function mapStateToProps(state) {
  return {
    isVisible: isVisibleSelector(state)
  }
}

module.exports = connect(
  mapStateToProps
)(
  TopCallToActionExplainerApp
)

const isVisibleSelector = createSelector(
  [
    state => state.env.browser,
    state => state.env.nativeEmbedded
  ],
  (browser, nativeEmbedded) => {
    if (browser.get('native') || nativeEmbedded) {
      return false
    }
    return Boolean(
      browser.get('android') ||
      browser.get('ios')
    )
  }
)
